export default __webpack_public_path__ + "static/media/asia_banner.69b9e6b6.png";